module.exports = __webpack_public_path__ + "img/thumbnail_AmericanAlligator_j_normal.5b7148bd.png";